/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const PropertyNuts = ({ className, imageClassName, image = "/img/image-1-1-2x.png" }) => {
  return (
    <div className={`property-NUTS ${className}`}>
      <img className={`image ${imageClassName}`} alt="Image" src={image} />
    </div>
  );
};

PropertyNuts.propTypes = {
  image: PropTypes.string,
};
